module.exports = __webpack_public_path__ + "images/emoji/white_small_square.fdca22fcc938c697666a.png";